'use client';

import { useServerInsertedHTML } from 'next/navigation';
import { ReactElement, useState, type PropsWithChildren } from 'react';
import { ServerStyleSheet, StyleSheetManager } from 'styled-components';

export default function StyledComponentsRegistry({ children }: PropsWithChildren): ReactElement {
	// Only create stylesheet once with lazy initial state
	// x-ref: https://reactjs.org/docs/hooks-reference.html#lazy-initial-state
	const [styledComponentsStyleSheet] = useState(() => new ServerStyleSheet());

	useServerInsertedHTML(() => {
		const styles = styledComponentsStyleSheet.getStyleElement();
		styledComponentsStyleSheet.instance.clearTag();
		return <>{styles}</>;
	});

	// Always wrap in StyleSheetManager to ensure animations work during client-side hydration
	if (typeof window !== 'undefined') {
		return <StyleSheetManager>{children}</StyleSheetManager>;
	}

	return <StyleSheetManager sheet={styledComponentsStyleSheet.instance}>{children}</StyleSheetManager>;
}
